import React from 'react';

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import InventoryIcon from '@mui/icons-material/Inventory';
import HelpIcon from '@mui/icons-material/Help';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import {
  DASHBOARD,
  HELP,
  INVENTORY,
  CATALOG,
  ORDER,
  ROLE,
  STORE_USER,
  STORE_USER_ADD,
  STORE_USER_EDIT,
} from '@jumbo/utils/constants/routes';
import SettingsIcon from '@mui/icons-material/Settings';

const menus = [
  {
    label: 'Home',
    type: 'section',
    children: [
      {
        uri: DASHBOARD,
        label: 'Dashboard',
        type: 'nav-item',
        icon: <DashboardOutlinedIcon sx={{ fontSize: 20 }} />,
        permission: 'All',
      },
      {
        uri: INVENTORY,
        label: 'Inventory',
        type: 'nav-item',
        icon: <InventoryIcon sx={{ fontSize: 20 }} />,
        permission: 'list-inventory',
      },
      {
        uri: ORDER,
        label: 'Orders',
        type: 'nav-item',
        icon: <ShoppingCartIcon sx={{ fontSize: 20 }} />,
        permission: 'list-order',
      },
      {
        uri: CATALOG,
        label: 'Catalog',
        type: 'nav-item',
        icon: <MenuBookIcon sx={{ fontSize: 20 }} />,
        target: '_blank',
        permission: 'All',
      },
      {
        label: 'Settings',
        type: 'collapsible',
        icon: <SettingsIcon sx={{ fontSize: 20 }} />,
        children: [
          {
            uri: ROLE,
            label: 'Role & Permission',
            type: 'nav-item',
            permission: 'list-role',
          },
          {
            uri: STORE_USER,
            label: 'Manage Users',
            type: 'nav-item',
            permission: 'list-user',
            isActiveUri: [STORE_USER, STORE_USER_ADD, STORE_USER_EDIT],
          },
        ],
      },
      {
        uri: HELP,
        label: 'Help',
        type: 'nav-item',
        icon: <HelpIcon sx={{ fontSize: 20 }} />,
        permission: 'All',
      },
    ],
  },
];

export default menus;
